module.exports = __webpack_public_path__ + "images/ds-is-icon-python-scroll.webp";